import React from "react";

import Card from "react-bootstrap/Card";
import Stack from "react-bootstrap/Stack";

export default function TicketRow({ group }) {
  return (
    <Card body className="card--xs card--light card-with-border">
      <Stack
        direction="horizontal"
        gap={4}
        className="justify-content-between small small-bold"
      >
        <Stack direction="horizontal" gap={4}>
          <Stack direction="horizontal" gap={2}>
            <span className="text-muted fw-normal">Sec</span>
            <span>{group?.sectionNumber}</span>
          </Stack>
          {group?.rowNumber && (
            <Stack direction="horizontal" gap={2}>
              <span className="text-muted fw-normal">Row</span>
              <span>{group?.rowNumber}</span>
            </Stack>
          )}
          {group?.seats && (
            <Stack direction="horizontal" gap={2}>
              <span className="text-muted fw-normal">Seat</span>
              <span>{group?.seats}</span>
            </Stack>
          )}
        </Stack>
        <span>{group?.offer?.name || "N/A"}</span>
      </Stack>
    </Card>
  );
}
